var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 13.5998L4.4 9.1998L0 7.1998L4.4 5.1998L6.4 0.799805L8.4 5.1998L12.8 7.1998L8.4 9.1998L6.4 13.5998ZM12.8 15.1998L11.8 12.9998L9.6 11.9998L11.8 10.9998L12.8 8.7998L13.8 10.9998L16 11.9998L13.8 12.9998L12.8 15.1998Z",
    fill: "#7500C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.dc8263c95b8d291ddab3eba278154445.svg";
export { ForwardRef as ReactComponent };